import React, { useState, useEffect } from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import { departmentsService } from '../../../services/supabaseService';

const FilterControls = ({ 
  selectedDepartment, 
  onDepartmentChange, 
  selectedPeriod, 
  onPeriodChange,
  autoRefresh,
  onAutoRefreshToggle,
  onExport
}) => {
  const [departmentOptions, setDepartmentOptions] = useState([
    { value: 'all', label: 'All Departments' }
  ]);
  const [loadingDepartments, setLoadingDepartments] = useState(true);

  // Load departments from database
  useEffect(() => {
    const loadDepartments = async () => {
      try {
        setLoadingDepartments(true);
        const departments = await departmentsService?.getAll();
        const options = [
          { value: 'all', label: 'All Departments' },
          ...departments?.map(dept => ({
            value: dept?.name?.toLowerCase()?.replace(/\s+/g, '-'),
            label: dept?.name
          }))
        ];
        setDepartmentOptions(options);
      } catch (error) {
        console.error('Error loading departments:', error);
      } finally {
        setLoadingDepartments(false);
      }
    };

    loadDepartments();
  }, []);

  const periodOptions = [
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'last90days', label: 'Last 90 Days' },
    { value: 'last6months', label: 'Last 6 Months' },
    { value: 'last12months', label: 'Last 12 Months' },
    { value: 'ytd', label: 'Year to Date' }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 elevation-sm mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 flex-1">
          <Select
            label="Department"
            options={departmentOptions}
            value={selectedDepartment}
            onChange={onDepartmentChange}
            searchable
            disabled={loadingDepartments}
          />
          <Select
            label="Time Period"
            options={periodOptions}
            value={selectedPeriod}
            onChange={onPeriodChange}
          />
        </div>
        <div className="flex items-center gap-3 flex-wrap">
          <button
            onClick={onAutoRefreshToggle}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-smooth font-caption ${
              autoRefresh 
                ? 'bg-success/10 text-success border border-success' :'bg-muted text-muted-foreground border border-border'
            }`}
            aria-label={autoRefresh ? 'Auto-refresh enabled' : 'Auto-refresh disabled'}
          >
            <Icon name={autoRefresh ? 'RefreshCw' : 'RefreshCcw'} size={16} />
            <span className="text-sm whitespace-nowrap">Auto-Refresh</span>
          </button>
          <button
            onClick={onExport}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-smooth font-caption"
            aria-label="Export dashboard data"
          >
            <Icon name="Download" size={16} />
            <span className="text-sm whitespace-nowrap">Export</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;